/* eslint-disable complexity */
import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { FormError } from '@com-delta-idp/mnx-login-ui';
import { regexList } from './regex-list';

export const security_answer_one_check: ValidatorFn = (
  control: AbstractControl
): ValidationErrors | null => {
  if (control.value?.value === '') {
    return { error: 'INVALID_FIRST_SEC_ANS' };
  } else if (control.value?.value?.length < 4) {
    return { error: 'SEC_ANS_LESS_THAN_FOUR_CHAR' };
  } else {
    const errorValue = compareFieldValues(
      control,
      'answerTwo',
      'INVALID_FIRST_SEC_ANS'
    );
    if (errorValue?.error === 'ANS_IN_USE') {
      control.parent?.get('answerTwo')?.setErrors({ error: 'ANS_IN_USE' });
      return null;
    }
    if (control.parent?.get('answerTwo')?.errors?.error === 'ANS_IN_USE') {
      control.parent?.get('answerTwo')?.setErrors(null);
    }
    return errorValue;
  }
};

export const security_answer_two_check: ValidatorFn = (
  control: AbstractControl
): ValidationErrors | null => {
  const value = control.value?.value;
  if (value === '') {
    return { error: 'INVALID_SECOND_SEC_ANS' };
  } else if (value?.length < 4) {
    return { error: 'SEC_ANS_LESS_THAN_FOUR_CHAR' };
  } else {
    return compareFieldValues(control, 'answerOne', 'INVALID_SECOND_SEC_ANS');
  }
};

export const security_question_one_check: ValidatorFn = (
  control: AbstractControl
): ValidationErrors | null => {
  if (control.parent) {
    const questionOneValue = control.value?.label,
      questionTwoValue = control.parent?.get('questionTwo')?.value?.label;
    if (control.value === null) {
      return { error: 'SEL_FIRST_SEC_QUESTION' };
    }
    if (questionOneValue === questionTwoValue) {
      control.parent
        ?.get('questionTwo')
        ?.setErrors({ error: 'QUESTION_IN_USE' });
    } else if (
      control.parent?.get('questionTwo')?.errors?.error === 'QUESTION_IN_USE'
    ) {
      control.parent?.get('questionTwo')?.setErrors(null);
    }
  }
  return null;
};

export const security_question_two_check: ValidatorFn = (
  control: AbstractControl
): ValidationErrors | null => {
  if (control.parent) {
    const questionOneValue = control.parent?.get('questionOne')?.value?.label,
      questionTwoValue = control.value?.label;
    if (control.value === null) {
      return { error: 'SEL_SECOND_SEC_QUESTION' };
    }
    if (questionOneValue === questionTwoValue) {
      return { error: 'QUESTION_IN_USE' };
    } else if (
      control.parent?.get('questionTwo')?.errors?.error === 'QUESTION_IN_USE'
    ) {
      return null;
    }
  }
  return null;
};

function compareFieldValues(
  control: AbstractControl,
  controlName: string,
  defaultError: string
): FormError | null {
  const value = control.value?.value;
  if (value?.match(regexList.securityAnswer)) {
    if (control.parent !== undefined) {
      const securityAnswer2 = value?.toUpperCase();
      const securityAnswer1 =
        control.parent?.value[controlName]?.value.toUpperCase();

      if (securityAnswer1 === securityAnswer2) {
        return { error: 'ANS_IN_USE' };
      }
    }
    return null;
  }
  return { error: defaultError };
}
